import Image from "next/image";
import Link from "next/link";
import React from "react";

import { CUSTOMER_CARE_TEL } from "@/src/lib/util/config";
import { callHref } from "@/src/lib/util/callUtils";

function StickyRight() {
    return (
        <div className="fixed right-0 top-1/2 -translate-y-1/2 z-10">
            <div className="flex flex-col">
                <div className="md:w-12 w-8 md:h-12 h-8 bg-white rounded-tl-md rounded-bl-md shadow-xs mb-3 flex justify-center items-center change_responsive">
                    <Link href={callHref(CUSTOMER_CARE_TEL)} className="flex">
                        <Image
                            src="https://images.hod.care/icon/call_fixed.svg"
                            alt="Call"
                            width={27}
                            height={27}
                        ></Image>
                    </Link>
                </div>
                <div className="md:w-12 w-8 md:h-12 h-8 bg-white rounded-tl-md rounded-bl-md shadow-xs mb-3 flex justify-center items-center change_responsive">
                    <Link
                        className="flex"
                        href="https://link.hod.care/whatsapp"
                        target="_blank"
                    >
                        <Image
                            src="https://images.hod.care/icon/whatsapp.svg"
                            alt="Whatsapp"
                            width={28}
                            height={28}
                        ></Image>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default StickyRight;
